function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.3168 3.18879C70.5527 1.54909 68.9023 0.5 67.0869 0.5H4.9131C3.09766 0.5 1.44726 1.54909 0.683182 3.18879C-0.0809021 4.82848 0.180267 6.76065 1.35255 8.14087L25.1196 36.1238V60.8571C25.1196 62.4662 25.9564 63.9606 27.3311 64.8066C28.7059 65.6525 30.4225 65.7295 31.868 65.0098L44.3028 58.8194C45.8825 58.0329 46.8804 56.4252 46.8804 54.6667V36.1238L70.6475 8.14087C71.8197 6.76065 72.0809 4.82848 71.3168 3.18879ZM57.0366 9.78571L38.6568 31.4258C37.9449 32.264 37.5543 33.3261 37.5543 34.4238V51.7972L34.4457 53.3448V34.4238C34.4457 33.3261 34.0551 32.264 33.3432 31.4258L14.9634 9.78571H57.0366Z",
  fill: "currentColor"
});

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 72 66",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.4d0b30c8.svg";
export { ForwardRef as ReactComponent };